import React, { useEffect, useState } from "react";
import CygnusField from "../CygnusField/CygnusField";
import styles from "./MDMConfigColumns.module.css";
import { MDMField } from "../../MDMFieldsConfig.utils";
import { ThreeCircles } from "react-loader-spinner";
import { MDMConfigColumnsProps } from "./MDMConfigColumns.utils";

/**
 * MDMConfigColumns.tsx
 *
 * Renders categorized fields for Source or Target columns.
 * Used inside MDMFieldsConfig to show field options by category,
 * either to be added (source) or already configured (target).
 */
const MDMConfigColumns: React.FC<MDMConfigColumnsProps> = ({
  fields,
  columnId,
  columnTitle,
  activeCategory,
  isFieldsDataFetched = false,
  onAddField,
  onRemoveField,
}) => {
  const [internalFields, setInternalFields] = useState<
    Record<string, MDMField[]>
  >({});

  useEffect(() => {
    setInternalFields(fields || {});
  }, [fields]);

  // Determine if we're rendering the target column (selected fields)
  const isTarget = columnId === "target-column";

  return (
    <div className={styles.scrollableColumn}>
      <div className={styles.columnTitle}>{columnTitle ?? "Field Column"}</div>
      <div className={styles.fieldListWrapper}>
        <div className={styles.fieldList}>
          {isTarget ? (
            Object.keys(internalFields).length > 0 ? (
              // Source column: Show only active category
              Object.keys(internalFields).map((category) =>
                internalFields[category].length > 0 ? (
                  <div key={category} className={styles.categoryBlock}>
                    <p className={styles.categoryLabel}>{category}</p>
                    <div className={styles.categoryFields}>
                      {internalFields[category].map((field, index) => (
                        <CygnusField
                          key={field.field_code}
                          field={field}
                          onRemoveField={onRemoveField}
                        />
                      ))}
                    </div>
                    <hr />
                  </div>
                ) : category === "Client information" ? (
                  <h3 key={category} className={styles.emptyMessage}>
                    Add or remove fields to be configured
                  </h3>
                ) : null
              )
            ) : (
              <h3 className={styles.emptyMessage}>
                Add or remove fields to be configured
              </h3>
            )
          ) : Array.isArray(internalFields[activeCategory]) &&
            internalFields[activeCategory].length > 0 ? (
            internalFields[activeCategory].map((field, index) => (
              <CygnusField
                key={field.field_code}
                field={field}
                onAddField={onAddField}
              />
            ))
          ) : !isFieldsDataFetched ? (
            <div className={styles.loader}>
              <ThreeCircles
                height="50"
                width="50"
                color="#4fa94d"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel="three-circles-rotating"
                outerCircleColor="var(--theme1_primary)"
                innerCircleColor="var(--theme1_secondary)"
                middleCircleColor="var(--theme1_tertiary)"
              />
              Loading your fields...
            </div>
          ) : (
            // Empty fallback for source column
            <h3 className={styles.emptyMessage}>
              All fields have been selected.
            </h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default MDMConfigColumns;
